import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { getUserDetails, updateUsers } from '../../actions/userActions';
import { getForms } from '../../actions/formActions';
import { useDispatch, useSelector } from 'react-redux';
import SearchBox from './SearchBox/SearchBox';

const Account = (props) => {
  const searchFormKey = "user_edit_form";
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const formState = useSelector((state) => state.forms);
  const { userDetails = {} } = userState;
  const [updatedPayload, setUpdatedPayload] = useState({});
  const { formJson = {} } = formState;
  const searchBoxJson = formJson[searchFormKey] || {};
  const [fetchingSearchForm, setFetchingSearchForm] = useState(_.isEmpty(searchBoxJson));

  useEffect(() => {
    dispatch(getForms(searchFormKey));
    dispatch(getUserDetails());
  }, []);

  useEffect(() => {
    if (!_.isEmpty(userDetails)) {
      const { additionalInfo = {} } = userDetails;
      const { telegramChatId = '', ...restAddtionalInfo } = additionalInfo;
      setUpdatedPayload({ userDetails: { ...userDetails, telegramChatId }, ...restAddtionalInfo });
    }
  }, [userDetails]);

  useEffect(() => {
    if (!_.isEmpty(searchBoxJson)) {
      setFetchingSearchForm(false);
    }
  }, [searchBoxJson]);

  const handleSearch = (payload) => {
    const { userDetails: ud = {}, addressInfo = {} } = payload;
    const { telegramChatId = '', additionalInfo = {}, ...restUserDetails } = ud;
    const finalPayload = { ...restUserDetails, additionalInfo: { ...additionalInfo, telegramChatId, addressInfo } };
    dispatch(updateUsers(finalPayload));
  };

  return (
    <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
      <SearchBox
        searchBoxJson={searchBoxJson}
        onSearch={handleSearch}
        fetchingForm={fetchingSearchForm || _.isEmpty(updatedPayload)}
        updatedValues={updatedPayload}
      />
    </div>
  );
};

export default Account;
